import { useMemo } from 'react';
import { useAllNavLinks } from './useNavLinks';
import type { SavedNavLink } from '../types';

interface UseExistingSectionsState {
  sections: string[];
  isLoading: boolean;
  isError: boolean;
}

function normalizeSectionKey(section: string): string {
  return section.trim().toLowerCase();
}

function dedupeAndSortSections(sections: string[]): string[] {
  const canonicalByKey = new Map<string, string>();

  for (const section of sections) {
    const trimmed = section.trim();
    if (!trimmed) continue;
    const key = normalizeSectionKey(trimmed);
    if (!canonicalByKey.has(key)) {
      canonicalByKey.set(key, trimmed);
    }
  }

  return Array.from(canonicalByKey.values()).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' }),
  );
}

function collectSections(links: SavedNavLink[]): string[] {
  return links
    .map((link) => link.sectionName)
    .filter((section): section is string => !!section);
}

export function useExistingSections(): UseExistingSectionsState {
  const { data, isLoading, isError } = useAllNavLinks();

  const sections = useMemo(() => dedupeAndSortSections(collectSections(data)), [data]);

  return { sections, isLoading, isError };
}

